import { CommonModule, JsonPipe } from '@angular/common';
import { Component, computed, input, OnInit, output, signal } from '@angular/core';

import { ImportWizardService } from '../../import-wizard.service';
import { ImportWizardGeospatialPreviewComponent } from './step1-preview/import-wizard-geospatial-preview.component';
import { StepInterface, StepperComponent } from 'src/app/shared/stepper/stepper.component';
import { ImportWizardStep, ImportWizardStorage } from '../../import-wizard.storage';
import { ImportWizardPendingStorage } from '../../components/pending-list/import-wizard-pending-list.storage';
import { ImportWizardPendingService } from '../../components/pending-list/import-wizard-pending-list.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ImportWizardGeoSpatialMappingAdjustComponent } from './step2-mapping_adjusts/import-wizard-geospatial-mapping_adjust.component';
import { ImportWizardGeoSpatialConfirmationValidationComponent } from './step3-validation_confirm/import-wizard-geospatial-confirmation_validation.component';
import { DatasetType } from '@/app/dtos/import-wizard/import-wizard.dto';
import { ImportWizardGeospatialFeaturesListComponent } from './step0-kmz-kml-import-feature-list/import-wizard-geospatial-features-list.component';


@Component({
    selector: 'app-import-wizard-geospatial',
    templateUrl: './import-wizard-geospatial.component.html',
    styleUrls: ['./import-wizard-geospatial.component.scss'],
    imports: [
        CommonModule,
        ImportWizardGeospatialFeaturesListComponent,
        ImportWizardGeospatialPreviewComponent,
        ImportWizardGeoSpatialMappingAdjustComponent,
        ImportWizardGeoSpatialConfirmationValidationComponent,
        StepperComponent,
        AlertComponent
    ],
    providers: [
        // ImportWizardPendingService
    ],
    standalone: true
})
export class ImportWizardGeospatialComponent implements OnInit{
    _filename = computed(() => { 
        return this._state().MultiFeatured ? 
        this.importWizardStorage.state().filename.split('.')[0] : 
        this.importWizardStorage.state().filename;
    });

    _state = computed(() => this.importWizardStorage.state());

    _isMultiFeatured = computed(() => this.importWizardStorage.state().MultiFeatured);

    _currentStep = computed(() => this.importWizardStorage.step());
    _inViewStep = computed(() => this.importWizardStorage.inViewStep());
  
    steps = computed<StepInterface[]>(() => {
        const current = this._currentStep();
        const isMulti = this._isMultiFeatured();

        const previewStep: StepInterface = {
            id: ImportWizardStep.PREVIEW,
            label: 'Preview',
            stepNumber: 1,
            description: 'Visualize os dados a serem importados',
            isCompleted: current > ImportWizardStep.PREVIEW,
            isDisabled: false
        };

        const mappingStep: StepInterface = {
            id: ImportWizardStep.MAPPING_ADJUSTS,
            label: 'Mapeamento e Ajustes',
            stepNumber: 2,
            description: 'Mapeie e ajuste os dados',
            isCompleted: current > ImportWizardStep.MAPPING_ADJUSTS,
            isDisabled: current <= ImportWizardStep.PREVIEW
        };

        const validationStep: StepInterface = {
            id: ImportWizardStep.VALIDATION_CONFIRM,
            stepNumber: isMulti ? 2 : ImportWizardStep.VALIDATION_CONFIRM,
            label: 'Validação e Confirmação',
            description: 'Valide e confirme a importação',
            isCompleted: current > ImportWizardStep.VALIDATION_CONFIRM,
            isDisabled: current <= ImportWizardStep.MAPPING_ADJUSTS
        };

        if (!isMulti) {
            return [previewStep, mappingStep, validationStep];
        }

        // isMulti
        if (current === ImportWizardStep.PREVIEW) return [previewStep];
        if (current === ImportWizardStep.VALIDATION_CONFIRM) return [validationStep];
        return [];
    });

    hasMappingStepChanges = computed(() => this.importWizardStorage.mappingHasChanges());
    isAlertMappingHasChangesOpen = signal<boolean>(false);
    _redirectStep = signal<ImportWizardStep | null>(null);

    constructor(
        public importWizardService: ImportWizardService,
        public importWizardStorage: ImportWizardStorage,
        private importWizardPendingStorage: ImportWizardPendingStorage,
        private importWizardPendingService: ImportWizardPendingService
    ) {}

    ngOnInit(): void {
        if(this.importWizardStorage.state().isShared) return;
        // this.refetchPendingImports();
    }

    onStepChange(event: StepInterface) { 
        if(this._state().inViewStep === ImportWizardStep.MAPPING_ADJUSTS && this.hasMappingStepChanges()) {
            this._redirectStep.set(event.id);
            this.openAlertMappingHasChanges();
        } else { 
            this.importWizardStorage.redirectInViewStep(event.id);
        }
    }

    // private refetchPendingImports() {
    //     this.importWizardPendingService.useGetAllPendingImports(DatasetType.SPATIAL).subscribe({
    //         next: (data) => {
    //             this.importWizardPendingStorage.setPendingImports(data);
    //         },
    //         error: (error) => {
    //             console.error(error);
    //         }
    //     });
    // }

    private openAlertMappingHasChanges() { 
        this.isAlertMappingHasChangesOpen.set(true);
    }

    handleAlertMappingHasChangesConfirm() { 
        this.importWizardStorage.redirectInViewStep(this._redirectStep()!);
    }

    handleAlertMappingHasChangesCancel() { 
        this._redirectStep.set(null);
        this.isAlertMappingHasChangesOpen.set(false);
    }

    ImportWizardStep = ImportWizardStep;
}